var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnicargoWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 4.09375L0 8.40909V21.908H6.09375V12.7674H19.9062V21.908H26V8.40909L13 4.09375Z",
    fill: "#1D4650"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61719 21.908H18.3828V14.2908H7.61719V21.908ZM13.7617 15.8143H16.8594V17.3377H13.7617V15.8143ZM13.7617 18.8611H16.8594V20.3846H13.7617V18.8611ZM9.14062 15.8143H12.2383V17.3377H9.14062V15.8143ZM9.14062 18.8611H12.2383V20.3846H9.14062V18.8611Z",
    fill: "#1D4650"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnicargoWarehouse);
export default __webpack_public_path__ + "static/media/unicargo-warehouse.57b7661dd0b15f142b7c6e2a47db40c8.svg";
export { ForwardRef as ReactComponent };